import React, { useState } from "react";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import { CHANGED_INVENTORIES_API } from "../../../../../../Utilities/APIs/APIs";
import { Form } from "react-router-dom";
import ShortTextInput from "../../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import SelectInput from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import DateInput from "../../../../../Partials/Layouts/Forms/FormInputs/DateInput/DateInput";

function CreateChangedInventories({ id, triggerFetch, setShowCreateForm }) {
  const axiosInstance = useAxiosInstance();

  const [quantity, setQuantity] = useState("");
  const [date, setDate] = useState("");
  const [changeType, setChangeType] = useState("");

  // NEW: location controls
  const [splitMode, setSplitMode] = useState(false);
  const [productLocation, setProductLocation] = useState("");
  const [mainOffice, setMainOffice] = useState(0);
  const [showRoom, setShowRoom] = useState(0);
  const [wareHouse, setWareHouse] = useState(0);

  async function handleSubmit(e) {
    e.preventDefault();

    const base = { productSize: id, date, changeType };
    let payload = base;

    if (changeType === "newStock") {
      if (splitMode) {
        payload = {
          ...base,
          allocations: {
            mainOffice: Number(mainOffice) || 0,
            showRoom: Number(showRoom) || 0,
            wareHouse: Number(wareHouse) || 0,
          },
        };
      } else {
        payload = {
          ...base,
          quantity: Number(quantity) || 0,
          productLocation: productLocation || null, // null keeps legacy row behavior
        };
      }
    } else {
      // sold/return (legacy)
      payload = { ...base, quantity: Number(quantity) || 0 };
    }

    const response = await axiosInstance.post(CHANGED_INVENTORIES_API, payload);
    if (response) {
      triggerFetch();
      setShowCreateForm(false);
    }
  }

  const showLocationUi = changeType === "newStock";
  const totalPreview =
    (Number(mainOffice) || 0) +
    (Number(showRoom) || 0) +
    (Number(wareHouse) || 0);

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div className="form-section">
          <DateInput label={"Date"} value={date} setState={setDate} />

          <SelectInput
            label={"Change Type"}
            value={changeType}
            setState={(v) => {
              setChangeType(v);
              if (v !== "newStock") {
                setSplitMode(false);
                setProductLocation("");
              }
            }}
          >
            <SelectOption optionValue="" optionText="Select Change Type" />
            <SelectOption optionValue="sold" optionText="sold" />
            <SelectOption optionValue="return" optionText="return" />
            <SelectOption optionValue="newStock" optionText="newStock" />
          </SelectInput>

          {/* Quantity for non-newStock OR for newStock (single-location mode) */}
          {(!showLocationUi || !splitMode) && (
            <ShortTextInput
              label={`Quantity`}
              value={quantity}
              placeholder={`Enter Quantity`}
              setState={setQuantity}
            />
          )}

          {/* Location UI (only for newStock) */}
          {showLocationUi && (
            <div className="field">
              <div className="field__row">
                <label className="field__label">Location</label>
                <label className="field__toggle">
                  <input
                    type="checkbox"
                    checked={splitMode}
                    onChange={(e) => setSplitMode(e.target.checked)}
                  />
                  <span>Split across locations</span>
                </label>
              </div>

              {/* Single-location path */}
              {!splitMode && (
                <div className="mt-8">
                  <SelectInput
                    label={"Select Location"}
                    value={productLocation}
                    setState={setProductLocation}
                  >
                    <SelectOption optionValue="" optionText="(Optional) Select Location" />
                    <SelectOption optionValue="mainOffice" optionText="Main Office" />
                    <SelectOption optionValue="showRoom" optionText="Showroom" />
                    <SelectOption optionValue="wareHouse" optionText="Warehouse" />
                  </SelectInput>
                </div>
              )}

              {/* Split allocations path */}
              {splitMode && (
                <>
                  <div className="grid-3">
                    <div className="field">
                      <label className="field__label">Main Office Qty</label>
                      <input
                        type="number"
                        min="0"
                        className="input"
                        value={mainOffice}
                        onChange={(e) => setMainOffice(e.target.value)}
                      />
                    </div>
                    <div className="field">
                      <label className="field__label">Showroom Qty</label>
                      <input
                        type="number"
                        min="0"
                        className="input"
                        value={showRoom}
                        onChange={(e) => setShowRoom(e.target.value)}
                      />
                    </div>
                    <div className="field">
                      <label className="field__label">Warehouse Qty</label>
                      <input
                        type="number"
                        min="0"
                        className="input"
                        value={wareHouse}
                        onChange={(e) => setWareHouse(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="total-preview">
                    Total preview: {totalPreview}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        <FormSubmitButton text="Add Changed Inventories" />
      </Form>
    </div>
  );
}
export default CreateChangedInventories;
